const useValidation = () => {

  const validateName = (name) => {
    const regex = /^[\p{L}\p{N} .,'"_-]+$/gu;
    return name.trim() !== "" && regex.test(name);
  };

  const validateLocation = (location) => {
    const regex = /^[\p{L}0-9:+,.\-/#\s\\&•–"'،()\[\]]+$/gu;
    return location.trim() !== "" && regex.test(location);
  };

  return { validateName, validateLocation };
};

export default useValidation;